/**
 * The language of a page comes from its URL (C40): French pages live under /fr/, English
 * pages have no prefix. The router runs with the locale's basename, so links and
 * history.push stay in the same language; only full-page navigations need these helpers.
 */

export const LOCALES = ['en', 'fr'];
export const DEFAULT_LOCALE = 'en';

// The cookie that remembers a visitor's choice, so a plain URL opens in their language.
export const LOCALE_COOKIE = 'locale';

const FR_PREFIX = /^\/fr(?=[/?#]|$)/;

/** 'fr' for /fr and anything under it, 'en' otherwise. */
export const localeFromPath = path => (FR_PREFIX.test(path || '') ? 'fr' : DEFAULT_LOCALE);

/** The router basename for a locale: '/fr' or '' (English has no prefix). */
export const basenameForLocale = locale => (locale === 'fr' ? '/fr' : '');

/** The path without its locale prefix: '/fr/about?x=1' → '/about?x=1', '/fr' → '/'. */
export const stripLocalePrefix = path => {
  const stripped = (path || '/').replace(FR_PREFIX, '');
  return stripped.startsWith('/') ? stripped : `/${stripped}`;
};

/** The same page in the given locale: ('/fr/about', 'en') → '/about', ('/', 'fr') → '/fr'. */
export const pathForLocale = (path, locale) => {
  const unprefixed = stripLocalePrefix(path);
  const basename = basenameForLocale(locale);
  return basename && unprefixed === '/' ? basename : `${basename}${unprefixed}`;
};

/**
 * The locale of the page the browser is showing. For code outside React that runs only in the
 * browser (thunks, event handlers); components use intl.locale.
 */
export const currentLocale = () =>
  typeof window === 'undefined' ? DEFAULT_LOCALE : localeFromPath(window.location.pathname);
